import { IRuleRowModel } from '@cbridge-tools/rules-data-grid';

export const refreshIndexes = (rows: IRuleRowModel[], from: number, to: number) => {
  for (let i = from; i < to; i++) {
    rows[i].index = i;
  }
};
